import React from 'react';

import BookingClosedView from '../../BookingClosedView/BookingClosedView';
import OrderNotFoundView from '../../OrderNotFoundView/OrderNotFoundView';

export const withPaymentJourney = (WrappedComponent) => (props) => {
  const { booking: { statusCode } = {} } = props;

  if (statusCode === 400 || statusCode === 404) {
    return <OrderNotFoundView />;
  }

  if (statusCode === 423) {
    return <BookingClosedView />;
  }

  return <WrappedComponent {...props} />;
};
